module.exports = __webpack_public_path__ + "static/media/kfc.ab9e383d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/clients/kfc.png
// module id = 257
// module chunks = 0